module.exports = __webpack_public_path__ + "static/media/car2.2435bf47.jpg";